import React from 'react';
import { DESTINATION_TYPES } from '../../../containers/destination/constants/destinationTypes';
import { ModelStatusEnum } from '../../../containers/transform-model/model-status';
import { RawModel } from '../../../containers/transform-model/raw-models';
import TransformModelAPI from '../../../containers/transform-model/TransformModelAPI';
import { GlobalSearchItem, GlobalSearchRegistryItem } from '../../interfaces/global-search';
import { GenericListItemContent, GenericListItemContentProps } from './GenericListItemContent/GenericListItemContent';
import { GlobalSearchEntityCommonData } from './interfaces/global-search-entity';

export const GLOBAL_SEARCH_MODEL_KEY = 'models';

export const GlobalSearchModelRegistry: GlobalSearchRegistryItem<GlobalSearchEntityCommonData> = {
  key: GLOBAL_SEARCH_MODEL_KEY,
  maxItemsWhenNoFiltersApplied: 2,
  sortOrder: 3,
  title: 'Models',
  filters: [
    {
      value: GLOBAL_SEARCH_MODEL_KEY,
      label: 'Models'
    }
  ],
  viewAllRoute: '/model',
  inMemoryFiltering: true,
  dataResolver: () => TransformModelAPI.getModels()
      .then(res => {
        const models = res.data.filter(
          model => model?.status !== ModelStatusEnum.DRAFT.value
        ).map(GlobalSearchModelFactory);

        return [...models];
      }),
  renderItem: (item) => {
    const props: GenericListItemContentProps = {
      suffixIcon: item.icon,
      primaryText: item.name,
      secondaryText: item.data.displayType,
      primaryLogoProps: {
        logoURL: item.data.logoUrl,
        darkModeLogoURL: item.data.darkModeLogoUrl,
        primaryColor: DESTINATION_TYPES[item.data.type]?.primaryColor,
        darkModePrimaryColor: DESTINATION_TYPES[item.data.type]?.darkModePrimaryColor
      },
      primaryLogoTooltip: item.data.displayType
    };

    return (
      <GenericListItemContent {...props} />
    );
  }
};

export function GlobalSearchModelFactory(
  rawModel: RawModel
): GlobalSearchItem<GlobalSearchEntityCommonData> {
  let route = `/model/${ rawModel.seq_id }/overview`;

  if (rawModel.status === ModelStatusEnum.DRAFT.value) {
    route = `/model/draft/${ rawModel.seq_id }`;
  }

  return {
    data: {
      name: rawModel.destination.name,
      displayType: rawModel.destination.dest_type_display,
      type: rawModel.destination.dest_type,
      logoUrl: rawModel.destination.dest_type_logo_url,
      darkModeLogoUrl:
        rawModel.destination.dest_type_dark_mode_logo_url ?? rawModel.destination.dest_type_logo_url
    },
    key: `${rawModel.destination.dest_type}-model-${rawModel.seq_id}`,
    name: rawModel.name,
    exitURL: route,
    icon: 'models',
    searchKeywords: [rawModel.name, rawModel.destination.name, rawModel.destination.dest_type]
  };
}
